import { Component } from '@angular/core';

@Component({
  selector: 'app-logged-out-header',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
})
export class HeaderLoggedOutComponent {}
